import React, { Fragment } from "react";
import { INaeWidget } from "../../v3/utils";
import { BaseEntityWidgets } from "./widgets/base-entity.widgets";
import { GeneratedLayoutWidgets } from "../../layout/GeneratedLayoutWidgets";

export const NaeWidgets: INaeWidget[] = [
  ...GeneratedLayoutWidgets,
  ];
